import data from './data'
import methods from './methods'

export default {
  resourcePath: '/v1/professional/settings/profiles',
  data,
  methods,
  mounted () {
    this.doLoad()
  }
}



// WEBPACK FOOTER //
// ./src/app/employee/record/registration/resources/index.js